import React, { useState } from 'react';
import './style/HelpSupport.css';

const HelpSupport = () => {
  const [activeCategory, setActiveCategory] = useState('general');

  const faqCategories = {
    general: [
      {
        question: "How do I access NEET study materials?",
        answer: "You can access all NEET study materials from the 'Study Materials' section in the app. We provide chapter-wise notes, video lectures, and practice questions for Physics, Chemistry, and Biology."
      },
      {
        question: "Is the app free to use?",
        answer: "We offer both free and premium features. Basic study materials and some practice questions are free, while advanced features like detailed analytics and personalized coaching require a subscription."
      },
      {
        question: "Can I use the app on multiple devices?",
        answer: "Yes, you can access your account on up to 3 devices simultaneously. Your progress syncs across all devices in real-time."
      }
    ],
    study: [
      {
        question: "Are previous year question papers available?",
        answer: "Yes, we have a comprehensive collection of previous year NEET question papers from 2010 to 2023 with detailed solutions and explanations."
      },
      {
        question: "How often is the content updated?",
        answer: "We update our content regularly to match the latest NEET syllabus and exam pattern. Major updates happen annually, with minor updates throughout the year."
      },
      {
        question: "Do you provide topic-wise tests?",
        answer: "Yes, we offer extensive topic-wise tests for all subjects. You can practice specific topics and track your improvement over time."
      }
    ],
    technical: [
      {
        question: "The app is running slow. What should I do?",
        answer: "Try clearing the app cache, ensure you have a stable internet connection, or update to the latest version. If problems persist, contact our technical support."
      },
      {
        question: "How do I reset my password?",
        answer: "Go to the login screen, click 'Forgot Password', and enter your registered email. You'll receive a password reset link within 5 minutes."
      },
      {
        question: "Can I download content for offline use?",
        answer: "Yes, premium users can download study materials and practice tests for offline access. Go to the content section and click the download icon."
      }
    ]
  };

  return (
    <div className="help-support-page">
      <div className="page-header">
        <h1>Help & Support</h1>
        <p>Find answers to common questions and get help with our NEET preparation platform</p>
      </div>

      <div className="help-container">
        <div className="help-sidebar">
          <h3>Categories</h3>
          <button 
            className={`category-btn ${activeCategory === 'general' ? 'active' : ''}`}
            onClick={() => setActiveCategory('general')}
          >
            General
          </button>
          <button 
            className={`category-btn ${activeCategory === 'study' ? 'active' : ''}`}
            onClick={() => setActiveCategory('study')}
          >
            Study Materials
          </button>
          <button 
            className={`category-btn ${activeCategory === 'technical' ? 'active' : ''}`}
            onClick={() => setActiveCategory('technical')}
          >
            Technical Support
          </button>
        </div>

        <div className="help-content">
          <div className="faq-section">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-list">
              {faqCategories[activeCategory].map((faq, index) => (
                <div key={index} className="faq-item">
                  <h3>Q: {faq.question}</h3>
                  <p>A: {faq.answer}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="support-options">
            <h3>Still need help?</h3>
            <div className="support-cards">
              <div className="support-card">
                <div className="card-icon">📧</div>
                <h4>Email Support</h4>
                <p>Send us an email and we'll respond within 24 hours</p>
                <a href="mailto:support@neetprep.com">support@neetprep.com</a>
              </div>
              <div className="support-card">
                <div className="card-icon">💬</div>
                <h4>Live Chat</h4>
                <p>Get instant help through our in-app chat support</p>
                <button className="chat-btn">Start Chat</button>
              </div>
              <div className="support-card">
                <div className="card-icon">📞</div>
                <h4>Phone Support</h4>
                <p>Call us during business hours for immediate assistance</p>
                <a href="tel:+15551234567">+1 (555) 123-4567</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpSupport;